module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"_","commonjs2":"lodash","commonjs":"lodash","amd":"lodash"}
// module id = 1
// module chunks = 0